<template>
  <div class="card card-1 single-log">
     <i class="fa fa-sort-desc" aria-hidden="true" @click="showDetails = !showDetails"></i>
     <b-row>

       <b-col cols="4">{{ log.ParentStore.identifier }}</b-col>

       <b-col cols="3" class="text-success"><strong>{{ log.ParentStore.short_identifier }}{{ log.startOrderNumber }}</strong></b-col>
       <b-col cols="1">To</b-col>
       <b-col cols="3" class="text-danger"><strong>{{ log.ParentStore.short_identifier }}{{ log.endOrderNumber }}</strong>
       
          <span  v-clipboard:copy="`${log.ParentStore.short_identifier}${log.endOrderNumber + 1}`" v-clipboard:success="onCopy" class="text-dark m-l-15 copyToclip" ><i class="fa fa-clipboard" aria-hidden="true"></i></span>
       
       </b-col>
       
     </b-row>
     <b-row class="extraInfo m-t-20" v-if="showDetails">
       <b-col cols="4">
         Export by: {{ log.ExportedBy.username }}
       </b-col>
       <b-col cols="6">
         DateTime: {{  moment(log.createdAt).format('DD-MM-YYYY, h:mm a') }}
       </b-col>
     </b-row>
  </div>
</template>

<script>
  export default {
     data(){
       return {
         showDetails: false,
       }
     },
     props: {
       log: {
         type: Object,
         default: () => ({})
       }
     },
     methods: {
        onCopy(){
          this.$toasted.show("+1 Order Number Copied to Clipboard", {
              type: "info",
              action: {
                text: "Close",
                class: "toastBtnTxt",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
            });
       }
     }
  }
</script>

<style lang="scss" scoped>
  .single-log{
    padding: 5px;
    margin-bottom: 2px;
    font-size: 13px;
    color: rgb(56, 56, 56);
    position: relative;
    padding-right: 40px;
    border-radius: 3px;

     .copyToclip i{
          font-size: 12px;
      }

    i{
      position: absolute;
      right: 10px;
      top: 2px;
      cursor: pointer;
      font-size: 16px;
      z-index: 2;
    }
  }
  .extraInfo{
    font-size: 11px;
    color: rgb(175, 175, 175);
  }
 
</style>